import {CustomerData, CustomerFormField} from "../types/customer-modal.types";
import {resources} from "../../../../models/resource/resources";
import {RecordData} from "../../../../types/records-table.types";

export const customerResourceType = resources['customers'];

export const customerFormFields: Array<CustomerFormField> = [
  {
    label: 'Имя',
    fieldName: 'name',
    type: 'text'
  },
  {
    label: 'Телефон',
    fieldName: 'phone',
    type: 'number'
  },
  {
    label: 'Telegram',
    fieldName: 'telegramLink',
    type: 'text',
    platform: 'telegram'
  },
  {
    label: 'WhatsApp',
    fieldName: 'whatsappLink',
    type: 'text',
    platform: 'whatsapp'
  }
]

export const defaultCustomerData = {
  id: 0,
  name: '',
  telegramLink: '',
  whatsappLink: '',
  phone: ''
}

export function isCustomer(record: RecordData): record is CustomerData {
  return 'name' in record && 'phone' in record;
}
